import { useQuery } from "@tanstack/react-query";
import { Operator } from "@/shared/model/Operator";
import { getSYOperators } from "@/pages/sy/repositories/ChargeRepository";

export const useOperatorsQuery = () => {
  return useQuery({
    queryKey: ["operators"],
    queryFn: async ({ signal }) => {
      const resp = await getSYOperators(signal);
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as Operator[];
      }
      throw new Error(resp.message);
    },
  });
};
